const colorNotUsed = 'rgba(255, 255, 255, 0.00)';
const colors = {
  base: {
    primary: '#E7EEF3',
    secondary: '#E6EBE6',
    blue300: colorNotUsed,
    blue500: colorNotUsed,
    blue800: colorNotUsed,
    blueTransparent200: colorNotUsed,
    blueTransparent400: 'rgba(75, 100, 189, 0.24)',
    white: '#FFFFFF',
    whiteTransparent800: 'rgba(255, 255, 255, 0.8)',
    grey50: '#F5F5F5',
    grey100: '#F1F1F1',
    grey300: colorNotUsed,
    grey500: '#CCCCCC',
    grey600: '#808080',
    grey700: colorNotUsed,
    grey900: colorNotUsed,
    greyTransparent200: 'rgba(0, 0, 0, 0.12)',
    greyTransparent400: 'rgba(0, 0, 0, 0.24)',
    black: '#000000',
  },
  additional: {
    red500: '#FF3A44',
    red100: '#FFEBEC',
    orange500: colorNotUsed,
    orange100: colorNotUsed,
    yellow500: '#FFD600',
    yellow100: '#FFFBE6',
    green500: '#15CF74',
    green100: '#E8FAF1',
    blue500: '#446C88',
    blue200: '#C6DCEC',
    blue100: colorNotUsed,
    teal500: '#2EC0C1',
  },
  text: {
    primary: '#000000',
    secondary: 'rgba(0, 0, 0, 0.60)',
    subtle: 'rgba(0, 0, 0, 0.25)',
    accent: '#000000',
    accentBright: '#000000',
    error: '#FF3A44',
    reversedPrimary: '#FFFFFF',
    reversedSecondary: 'rgba(255, 255, 255, 0.70)',
  },
  gradients: {
    primary: 'linear-gradient(88deg, #C3AAB2 0.66%, #9EC 57.2%, #80C0C8 75.87%, #4B8BFA 98.72%)',
    secondary: 'linear-gradient(69deg, #C3AAB2 -4.77%, #9EC 46.72%, #80C0C8 90.23%, #4B8BFA 134.46%)',
    tertiary: [
      'radial-gradient',
      '(98.14% 120.08% at 7.24% 21%, #B5D39D 0%, #F1ACAC 25.66%, #BF98C6 54.47%, #7179EF 86.04%, #2833D0 100%)',
    ].join(''),
    notificationCardOverlay: 'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 75%)',
  },
  icon: {
    primary: 'rgba(0, 0, 0, 0.70)',
    secondary: 'rgba(0, 0, 0, 0.50)',
    subtle: 'rgba(0, 0, 0, 0.20)',
    primaryHovered: '#000000',
    hoverArea: 'rgba(0, 0, 0, 0.12)',
    accent: 'rgba(0, 0, 0, 0.70)',
    accentBright: 'rgba(0, 0, 0, 0.70)',
    error: '#FF3A44',
    reversedPrimary: 'rgba(255, 255, 255, 0.87)',
    reversedSecondary: 'rgba(255, 255, 255, 0.70)',
  },
};

const legacyColors = {
  // Layout
  layoutBackgroundPrimary: '#ffffff', // Page base background
  layoutBackgroundSecondary: '#E7EEF3', // Tall header & sidebar background
  layoutBackgroundTertiary: '#E6EBE6', // Additional background
  layoutBackgroundOutside: '#F5F5F5', // Fill color for browser area beyond 1680px width

  // Text colors
  textMainPrimary: '#000000', // Most text blocks, like headers, body texts, descriptions
  textMainSecondary: 'rgba(0, 0, 0, 0.6)', // Secondary texts, hints, component labels
  textMainSubtle: 'rgba(0, 0, 0, 0.25)', // Disabled text. Placeholders
  textAlternatePrimary: '#FFFFFF', // Color style for primery texts over inverted backgrounds
  textAlternateSecondary: 'rgba(255, 255, 255, 0.7)', // Color style for secondary texts over inverted backgrounds
  textErrors: '#FF3A44', // Error description under components

  // UI colors
  uIBase: '#000000', // Dividers. Components strokes
  uIBase2: '#808080', // Reserved
  uIBase4: '#CCCCCC', // Disabled components
  uIBase6: '#F1F1F1', // Components backgrounds
  uIIconBase: 'rgba(0, 0, 0, 0.7)', // Regular state of icons
  uIIconHovered: '#000000',
  uIIconDisabled: 'rgba(0, 0, 0, 0.2)',
  uIIconHoverArea: 'rgba(0, 0, 0, 0.12)', // Hover effects for icons
  uIBlueBase: '#446C88', // Labels
  uIBlueBase2: '#C6DCEC',
  uIBlueBackground: '#E7EEF3', // Components hover states. Backgrounds
  uIGreenBase: '#15CF74', // Labels
  uIGreenBackground: '#E8FAF1', // Background for banners & notifications
  uIYellowBase: '#FFD600', // Labels
  uIYellowBackground: '#FFFBE6', // Background for banners & notifications
  uIRedBase: '#FF3A44', // Labels.Icon-buttons with important actions
  uIRedBackground: '#FFEBEC', // Backgrounds for banners & notifications

  // Focused inputs. Hovered secondary buttons
  uIGradient1: 'linear-gradient(87.99deg, #C3AAB2 0.66%, #99EECC 57.2%, #80C0C8 75.87%, #4B8BFA 98.72%)',
  // Hovered primary buttons
  uIGradient2: 'linear-gradient(68.94deg, #C3AAB2 -4.77%, #99EECC 46.72%, #80C0C8 90.23%, #4B8BFA 134.46%)',
  // Border for panels
  uIGradient3: [
    'radial-gradient(',
    '92.76% 76.25% at 7.24% 21%, #B5D39D 0%, #F1ACAC 25.66%, #BF98C6 54.47%, #7179EF 86.04%, #2833D0 100%',
    ') 1'].join(''),
  // Gradient for Notifications
  uIGradient4: 'linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',

  // Dropdown menus
  dropmenuBackground: '#FFFFFF', // Menu background
  dropmenuHover: '#E7EEF3',
  dropmenuSelected: '#F1F1F1', // Selected options in menu

  // Footer
  footerBackground: '#000000',
  footerUIElements: '#FFFFFF',
  footerTextPrimary: '#FFFFFF',
  footerTextSecondary: 'rgba(255, 255, 255, 0.7)',

  // Loader
  loaderBody: '#000000',
  loaderBackground: '#FFFFFF',
  loaderOverlay: 'rgba(255, 255, 255, 0.8)',
  loaderRotationUnit: '#2EC0C1',

  // focus
  focusOutline: '#1751C1',
};

const borders = {
  radius3: 18,
  radius2: 12,
  radius1: 6,
  radiusHalfBlock: 3,
  radiusZero: 0,
};

const shadows = {
  dropShadow200: '0px 2px 6px 0px rgba(0, 0, 0, 0.25)',
  dropShadow400: '0px 2px 8px 0px rgba(0, 0, 0, 0.20)',
};

const layout = {
  backgroundPrimary: colors.base.white,
  backgroundSecondary: colors.base.primary,
  backgroundTertiary: colors.base.secondary,
  backgroundOutside: colors.base.grey50,
  divider700: colors.base.black,
  divider500: colorNotUsed,
  divider300: colors.base.grey500,
  contentAreaShadow: colorNotUsed,
  dialogOverlay: 'rgba(0, 0, 0, 0.25)',
};
const spacing = 6;

export const DiiaLight = {
  spacing,
  fonts: [
    {
      fontFamily: 'e-Ukraine-Regular',
      fontStyle: 'normal',
      fontWeight: 400,
      fontName: 'e-Ukraine-Regular.woff2',
      fontFormat: 'woff2',
    },
    {
      fontFamily: 'e-Ukraine-Head',
      fontStyle: 'normal',
      fontWeight: 400,
      fontName: 'e-UkraineHead-Regular.woff2',
      fontFormat: 'woff2',
    },
    {
      fontFamily: 'e-Ukraine-Light',
      fontStyle: 'normal',
      fontWeight: 400,
      fontName: 'e-Ukraine-Light.woff2',
      fontFormat: 'woff2',
    },
    {
      fontFamily: 'RobotoMono-Regular',
      fontStyle: 'normal',
      fontWeight: 400,
      fontName: 'RobotoMono-Regular.woff2',
      fontFormat: 'woff2',
    },
  ],
  typography: {
    h1: {
      fontFamily: 'e-Ukraine-Regular',
      fontSize: '54px',
      lineHeight: '72px',
    },
    h2: {
      fontFamily: 'e-Ukraine-Regular',
      fontSize: '38px',
      lineHeight: '48px',
    },
    h3: {
      fontFamily: 'e-Ukraine-Regular',
      fontSize: '30px',
      lineHeight: '42px',
    },
    h4: {
      fontFamily: 'e-Ukraine-Regular',
      fontSize: '26px',
      lineHeight: '36px',
    },
    h5: {
      fontFamily: 'e-Ukraine-Regular',
      fontSize: '18px',
      lineHeight: '24px',
    },
    h6: {
      fontFamily: 'e-Ukraine-Regular',
      fontSize: '16px',
      lineHeight: '24px',
    },
    h7: {
      fontFamily: 'e-Ukraine-Regular',
      fontSize: '12px',
      lineHeight: '18px',
    },
    textBig: {
      fontFamily: 'e-Ukraine-Light',
      fontSize: '18px',
      lineHeight: '24px',
    },
    textBigCompact: {
      fontFamily: 'e-Ukraine-Light',
      fontSize: '18px',
      lineHeight: '18px',
    },
    textRegular: {
      fontFamily: 'e-Ukraine-Light',
      fontSize: '16px',
      lineHeight: '24px',
    },
    textRegularCompact: {
      fontFamily: 'e-Ukraine-Light',
      fontSize: '16px',
      lineHeight: '18px',
    },
    textSmall: {
      fontFamily: 'e-Ukraine-Light',
      fontSize: '14px',
      lineHeight: '24px',
    },
    textSmallCompact: {
      fontFamily: 'e-Ukraine-Light',
      fontSize: '14px',
      lineHeight: '18px',
    },
    textTiny: {
      fontFamily: 'e-Ukraine-Light',
      fontSize: '12px',
      lineHeight: '18px',
    },
    textTinyCompact: {
      fontFamily: 'e-Ukraine-Light',
      fontSize: '12px',
      lineHeight: '12px',
    },
    accentXL: {
      fontFamily: 'e-Ukraine-Regular',
      fontSize: '26px',
      lineHeight: '36px',
    },
    accentBig: {
      fontFamily: 'e-Ukraine-Regular',
      fontSize: '18px',
      lineHeight: '24px',
    },
    accentBigCompact: {
      fontFamily: 'e-Ukraine-Regular',
      fontSize: '18px',
      lineHeight: '28px',
    },
    accentRegular: {
      fontFamily: 'e-Ukraine-Regular',
      fontSize: '16px',
      lineHeight: '24px',
    },
    accentRegularCompact: {
      fontFamily: 'e-Ukraine-Regular',
      fontSize: '16px',
      lineHeight: '28px',
    },
    accentSmall: {
      fontFamily: 'e-Ukraine-Regular',
      fontSize: '14px',
      lineHeight: '24px',

    },
    accentSmallCompact: {
      fontFamily: 'e-Ukraine-Regular',
      fontSize: '14px',
      lineHeight: '18px',
    },
    accentTiny: {
      fontFamily: 'e-Ukraine-Regular',
      fontSize: '12px',
      lineHeight: '18px',
    },
    accentTinyCompact: {
      fontFamily: 'e-Ukraine-Regular',
      fontSize: '12px',
      lineHeight: '12px',
    },
    linkRegular: {
      fontFamily: 'e-Ukraine-Light',
      fontSize: '16px',
      lineHeight: '24px',
      textDecoration: 'underline',
    },
    linkSmall: {
      fontFamily: 'e-Ukraine-Light',
      fontSize: '14px',
      lineHeight: '24px',
      textDecoration: 'underline',
    },
    linkTiny: {
      fontFamily: 'e-Ukraine-Light',
      fontSize: '12px',
      lineHeight: '18px',
      textDecoration: 'underline',
    },
  },
  borders,
  shadows,
  flags: {
    boxStyle: 'stroke',
    showIcons: false,
  },
  colors: {
    ...legacyColors,
    layout,
    text: colors.text,
    base: colors.base,
    icon: colors.icon,
    additional: colors.additional,
    navigation: {
      navLink: {
        corner: borders.radiusZero,
        enabled: {
          name: colors.text.accent,
          icon: colorNotUsed,
        },
        selected: {
          fill: colorNotUsed,
          name: colors.text.accent,
          icon: colorNotUsed,
          stroke: layout.divider700,
        },
        hovered: {
          fill: colorNotUsed,
          name: colors.text.accent,
          icon: colorNotUsed,
          stroke: layout.divider700,
        },
        disabled: {
          fill: colorNotUsed,
          name: colors.text.subtle,
          icon: colorNotUsed,
        },
      },
      textLink: {
        enabled: {
          text: colors.text.primary,
        },
        hovered: {
          text: colors.text.primary,
        },
        disabled: {
          text: colors.text.subtle,
        },
      },
      accountMenu: {
        divider: layout.divider300,
        corner: borders.radiusZero,
        enabled: {
          text: colors.text.accent,
          icon: colors.icon.accent,
        },
        selected: {
          fill: colorNotUsed,
          name: colors.text.accent,
          icon: colors.icon.accent,
          stroke: layout.divider700,
        },
        hovered: {
          fill: colorNotUsed,
          name: colors.text.accent,
          icon: colors.icon.accent,
          stroke: layout.divider700,
        },
        focused: {
          fill: colorNotUsed,
          name: colors.text.accent,
          icon: colors.icon.accent,
          stroke: layout.divider700,
        },
        disabled: {
          fill: colorNotUsed,
          name: colors.text.subtle,
          icon: colors.icon.subtle,
        },
      },
      topBar: {
        title: colors.text.accent,
      },
      logoLink: {
        name: colors.text.accent,
        divider: layout.divider300,
      },
      tab: {
        enabled: {
          name: colors.text.secondary,
        },
        selected: {
          name: colors.text.primary,
          fill: colorNotUsed,
        },
        hovered: {
          name: colors.text.primary,
          fill: colorNotUsed,
        },
        disabled: {
          name: colors.text.subtle,
          fill: colorNotUsed,
        },
      },
    },
    pageElements: {
      menuPanel: {
        enabled: {
          background: colors.base.grey100,
          counter: colors.text.primary,
          title: colors.text.primary,
          description: colors.text.primary,
        },
        hovered: {
          background: colors.base.primary,
          counter: colors.text.primary,
          title: colors.text.primary,
          description: colors.text.primary,
          icon: colors.icon.accent,
        },
        disabled: {
          background: colors.base.grey100,
          counter: colors.text.subtle,
          title: colors.text.subtle,
          description: colors.text.subtle,
        },
      },
      tooltip: {
        fill: layout.backgroundPrimary,
        text: colors.text.primary,
        stroke: colors.base.grey500,
      },
      dropdownMenu: {
        dropdownMenuShadow: shadows.dropShadow200,
      },
      dropdownMenuOption: {
        enabled: {
          name: colors.text.primary,
          description: colors.text.secondary,
        },
        hovered: {
          name: colors.text.primary,
          description: colors.text.secondary,
          background: colors.base.primary,
        },
        selected: {
          name: colors.text.primary,
          description: colors.text.secondary,
          icon: colors.icon.primary,
        },
        disabled: {
          name: colors.text.subtle,
          description: colors.text.subtle,
        },
        enabledError: {
          name: colors.text.error,
          description: colors.text.secondary,
        },
        hoveredError: {
          name: colors.text.error,
          description: colors.text.secondary,
          background: colors.additional.red100,
        },
      },
      dropdownMenuSubsection: {
        name: colors.text.secondary,
      },
      table: {
        background: colorNotUsed,
        corner: borders.radiusZero,
        border: colorNotUsed,
        headerDivider: layout.divider700,
        rowDivider: layout.divider300,
        rowSelected: colors.base.primary,
        headerCell: {
          enabled: {
            name: colors.text.secondary,
            icon: colors.icon.secondary,
          },
          hovered: {
            fill: colorNotUsed,
            name: colors.text.primary,
            icon: colors.icon.primary,
          },
          disabled: {
            name: colors.text.subtle,
            icon: colors.icon.subtle,
          },
        },
      },
      flyOutNotifications: {
        dropdownMenuShadow: shadows.dropShadow200,
        corner: borders.radiusZero,
        title: colors.text.primary,
        description: colors.text.primary,
        backgroundInfo: colors.base.primary,
        backgroundSuccess: colors.additional.green100,
        backgroundWarning: colors.additional.yellow100,
        backgroundError: colors.additional.red100,
        backgroundService: colors.base.grey100,
        strokeInfo: colorNotUsed,
        strokeSuccess: colorNotUsed,
        strokeWarning: colorNotUsed,
        strokeError: colorNotUsed,
        strokeService: colorNotUsed,
      },
      notificationCard: {
        title: colors.text.primary,
        description: colors.text.primary,
        dateTime: colors.text.secondary,
        background: colorNotUsed,
        stroke: colors.base.black,
        corner: borders.radiusZero,
        rowsDistance: 0,
        fadingOverlay: colors.gradients.notificationCardOverlay,
      },
      indicator: {
        text: colors.text.reversedPrimary,
        fill: colors.additional.green500,
        corner: borders.radiusZero,
      },
      profileCard: {
        stroke: colors.gradients.tertiary,
        username: colors.text.accent,
        infoLabel: colors.text.secondary,
        infoText: colors.text.primary,
        infoDivider: colors.base.grey500,
        background: colorNotUsed,
      },
      serviceCard: {
        corner: 0,
        rowsDistance: 0,
        enabled: {
          name: colors.text.primary,
          fill: colorNotUsed,
          emblemBackground: colors.base.white,
          proceedIcon: colors.icon.primary,
          stroke: colors.base.black,
        },
        hovered: {
          name: colors.text.reversedPrimary,
          fill: colors.base.black,
          emblemBackground: colors.base.white,
          proceedIcon: colors.icon.reversedPrimary,
        },
        disabled: {
          name: colors.text.subtle,
          fill: colorNotUsed,
          emblemBackground: colors.base.white,
          proceedIcon: colors.icon.subtle,
          stroke: colors.base.black,
        },
        pressed: {
          name: colors.text.reversedPrimary,
          fill: colors.base.black,
          emblemBackground: colors.base.white,
          proceedIcon: colors.icon.reversedPrimary,
        },
      },
      versionMenu: {
        hovered: {
          stroke: colors.base.black,
        },
        pressed: {
          stroke: colors.gradients.primary,
        },
      },
      coloredBox: {
        background: colorNotUsed,
        stroke: colors.gradients.tertiary,
      },
      accountType: {
        corner: 0,
        enabled: {
          name: colors.text.secondary,
          fill: colorNotUsed,
          stroke: colors.base.grey500,
        },
        hovered: {
          name: colors.text.primary,
          fill: colorNotUsed,
          stroke: colors.base.black,
        },
        selected: {
          name: colors.text.primary,
          fill: colors.base.primary,
          stroke: colorNotUsed,
        },
        disabled: {
          name: colors.text.subtle,
          fill: colorNotUsed,
          stroke: colors.base.grey500,
        },
      },
      logo: {
        enabled: {
          fill: colors.base.black,
        },
      },
      loader: {
        rotationUnit: colors.additional.teal500,
        body: colors.base.black,
        overlay: colors.base.whiteTransparent800,
        descriptionText: colors.text.primary,
        descriptionBackground: colors.base.white,
        descriptionCorner: borders.radiusZero,
      },
    },
    inputs: {
      label: {
        name: colors.text.secondary,
        requiredMark: colors.text.error,
      },
      footNote: {
        text: colors.text.primary,
        icon: colors.icon.primary,
        background: colors.additional.yellow100,
      },
      errorMessage: {
        text: colors.text.error,
        icon: colors.icon.error,
      },
      inputField: {
        corner: borders.radiusZero,
        textRegular: colors.text.primary,
        textPlaceholder: colors.text.subtle,
        textDisabled: colors.text.subtle,
        textError: colors.text.primary,
        enabled: {
          stroke: colors.base.black,
          prefixIcon: colors.icon.secondary,
          dropIcon: colors.icon.primary,
        },
        hovered: {
          stroke: colors.base.black,
          prefixIcon: colors.icon.secondary,
          dropIcon: colors.icon.primary,
        },
        focused: {
          stroke: colors.gradients.primary,
          prefixIcon: colors.icon.secondary,
          dropIcon: colors.icon.primary,
        },
        disabled: {
          fill: colorNotUsed,
          stroke: colors.base.grey500,
          prefixIcon: colors.icon.subtle,
          dropIcon: colors.icon.subtle,
        },
        readOnly: {
          fill: colorNotUsed,
          stroke: colors.base.grey500,
          prefixIcon: colors.icon.secondary,
          dropIcon: colors.icon.subtle,
        },
        error: {
          stroke: colors.additional.red500,
          prefixIcon: colors.icon.secondary,
          dropIcon: colors.icon.primary,
        },
      },
      fileUpload: {
        progressIndicator: {
          fill: colors.base.primary,
          corner: borders.radiusZero,
        },
        dropArea: {
          enabled: {
            border: colors.base.grey500,
          },
          hovered: {
            border: colors.base.black,
          },
        },
      },
      dateTimePicker: {
        dayCell: {
          corner: borders.radiusZero,
          enabled: {
            text: colors.text.primary,
            todayStroke: colors.base.black,
          },
          hovered: {
            text: colors.text.primary,
            todayStroke: colors.base.black,
            fill: colors.base.greyTransparent200,
          },
          selected: {
            text: colors.text.reversedPrimary,
            fill: colors.base.black,
          },
          disabled: {
            text: colors.text.subtle,
            todayStroke: colors.base.black,
          },
        },
        amPmSwitch: {
          corner: 0,
          enabled: {
            text: colors.text.primary,
          },
          hovered: {
            text: colors.text.primary,
            fill: colors.base.greyTransparent200,
          },
          pressed: {
            text: colors.text.primary,
            fill: colors.base.greyTransparent400,
          },
          disabled: {
            text: colors.text.subtle,
          },
        },
      },
    },
    controls: {
      button: {
        primary: {
          enabled: {
            fill: colors.base.black,
            name: colors.text.reversedPrimary,
            icon: colors.icon.reversedPrimary,
          },
          hovered: {
            fill: colors.gradients.secondary,
            name: colors.text.primary,
            icon: colors.icon.primaryHovered,
          },
          disabled: {
            fill: colors.base.grey500,
            name: colors.text.reversedPrimary,
            icon: colors.icon.reversedPrimary,
          },
          pressed: {
            fill: colors.base.black,
            name: colors.text.reversedPrimary,
            icon: colors.icon.reversedPrimary,
          },
        },
        secondary: {
          enabled: {
            stroke: colors.base.black,
            name: colors.text.primary,
            icon: colors.icon.primary,
          },
          hovered: {
            fill: colorNotUsed,
            stroke: colors.gradients.primary,
            name: colors.text.primary,
            icon: colors.icon.primary,
          },
          disabled: {
            stroke: colors.base.grey500,
            name: colors.text.subtle,
            icon: colors.icon.subtle,
          },
          pressed: {
            fill: colorNotUsed,
            stroke: colors.base.black,
            name: colors.text.primary,
            icon: colors.icon.primary,
          },
        },
        tertiary: {
          enabled: {
            fill: colors.base.primary,
            name: colors.base.primary,
            icon: colors.base.primary,
          },
          hovered: {
            fill: colors.base.primary,
            name: colors.base.primary,
            icon: colors.base.primary,
          },
          disabled: {
            fill: colors.base.primary,
            name: colors.base.primary,
            icon: colors.base.primary,
          },
          pressed: {
            fill: colors.base.primary,
            name: colors.base.primary,
            icon: colors.base.primary,
          },
        },
      },
      options: {
        enabled: {
          text: colors.text.primary,
          icon: colors.icon.primary,
        },
        hovered: {
          text: colors.text.primary,
          icon: colors.icon.primary,
          hoverArea: colors.base.greyTransparent200,
        },
        pressed: {
          text: colors.text.primary,
          icon: colors.icon.primaryHovered,
          hoverArea: colors.base.greyTransparent400,
        },
        disabled: {
          text: colors.text.subtle,
          icon: colors.icon.subtle,
        },
        readOnly: {
          text: colors.text.primary,
          icon: colors.icon.subtle,
        },
        error: {
          text: colors.text.primary,
          icon: colors.icon.primary,
        },
      },
      buttonIcon: {
        enabled: {
          fill: colors.icon.primary,
        },
        hovered: {
          fill: colors.icon.primaryHovered,
          hoverArea: colors.base.greyTransparent200,
        },
        disabled: {
          fill: colors.icon.subtle,
        },
        pressed: {
          fill: colors.icon.primaryHovered,
          hoverArea: colors.base.greyTransparent400,
        },
      },
      chips: {
        enabled: {
          text: colors.text.primary,
          fill: colors.base.grey100,
        },
        hovered: {
          text: colors.text.primary,
          fill: colors.base.primary,
        },
        disabled: {
          text: colors.text.subtle,
          fill: colors.base.grey100,
        },
        pressed: {
          text: colors.text.primary,
          fill: colors.base.grey500,
        },
      },
      buttonText: {
        enabled: {
          name: colors.text.primary,
          icon: colors.icon.primary,
        },
        hovered: {
          fill: colors.base.greyTransparent200,
          name: colors.text.primary,
          icon: colors.icon.primaryHovered,
        },
        disabled: {
          name: colors.text.subtle,
          icon: colors.icon.subtle,
        },
        pressed: {
          name: colors.text.primary,
          icon: colors.icon.primaryHovered,
          fill: colors.base.greyTransparent400,
        },
      },
    },
  },
};
